import { render, staticRenderFns } from "./HomeCardContent.vue?vue&type=template&id=40ba2d53&scoped=true&"
import script from "./HomeCardContent.vue?vue&type=script&lang=js&"
export * from "./HomeCardContent.vue?vue&type=script&lang=js&"
import style0 from "./HomeCardContent.vue?vue&type=style&index=0&id=40ba2d53&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ba2d53",
  null
  
)

export default component.exports